import type { FC } from "react";
import clsx from "clsx";

interface TabHeaderProps {
  title: string;
  className?: string;
  hideDivider?: boolean;
}

const TabHeader: FC<TabHeaderProps> = (props) => {
  const { title, className = "", hideDivider = false } = props;

  return (
    <div
      className={clsx(
        "w-full px-[5px] text-[#007fb6] font-bold",
        !hideDivider && "border-b-2 border-black",
        className
      )}
      data-testid="heading"
    >
      {title}
    </div>
  );
};

export default TabHeader;
